import React from "react";
import { Route, Switch } from "react-router-dom";

import Home from "../pages/Home";
import Login from "../pages/Login";
import Logout from "../pages/Logout";
import OIDC from "../pages/OIDC";
import Dashboard from "../pages/Dashboard";
import Profile from "../pages/Profile";
import Activity from "../pages/Activity";
import ActivityWizard from "../pages/Activity/Wizard";
import Exercise from "../pages/Exercise";
import ExerciseWizard from "../pages/Exercise/Wizard";
import Classes from "../pages/Classes";
import ClassesWizard from "../pages/Classes/Wizard";
import Programs from "../pages/Programs";
import ProgramsWizard from "../pages/Programs/Wizard";
import DigitalCoaching from "../pages/DigitalCoaching";
import IndividualCoachWizard from "../pages/DigitalCoaching/IndividualCoach/Wizard";
import DigitalCoachingCohortDetail from "../pages/DigitalCoaching/Cohort";
import DigitalCoachingCohortList from "../pages/DigitalCoaching/CohortList";
import Settings from "../pages/Settings";
import Staff from "../pages/Staff";
import NotFound from "../pages/NotFound";

import AuthenticatedRoute from "./AuthenticatedRoute";
import UnauthenticatedRoute from "./UnauthenticatedRoute";

const routerSwitch = ({ isAuthenticated }) => (
  <Switch>
    <UnauthenticatedRoute path="/" exact component={Home} isAuthenticated={isAuthenticated} />
    <UnauthenticatedRoute path="/login" exact component={Login} isAuthenticated={isAuthenticated} />
    <Route path="/logout" exact component={Logout} />
    <UnauthenticatedRoute path="/oidc" exact component={OIDC} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/dashboard" exact component={Dashboard} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/profile" exact component={Profile} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/activities" exact component={Activity} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/activities/:uid" exact component={ActivityWizard} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/(exercises|exercises/demos)" exact component={Exercise} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/(classes|classes/drafts|classes/digital)" exact component={Classes} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/classes/:uid" exact component={ClassesWizard} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/exercises/:uid" exact component={ExerciseWizard} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/(programs|programs/drafts|programs/wellness)" exact component={Programs} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/(digital-coaching|digital-coaching/individual-coaching)" exact component={DigitalCoaching} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/digital-coaching/individual-coaching/:uid" exact component={IndividualCoachWizard} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/digital-coaching/:uid" exact component={DigitalCoachingCohortList} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/digital-coaching/:uid/cohort/:cid" exact component={DigitalCoachingCohortDetail} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/programs/:uid" exact component={ProgramsWizard} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/(settings|settings/account|settings/password|settings/stripe|settings/stripe/callback)" exact component={Settings} isAuthenticated={isAuthenticated} />
    <AuthenticatedRoute path="/(staff|staff/workouts|staff/transfer|staff/welcome|staff/release|staff/promo)" staff exact component={Staff} isAuthenticated={isAuthenticated} />
    { /* Finally, catch all unmatched routes */ }
    <Route component={NotFound} />
  </Switch>
);

export default routerSwitch;
